"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validatePassword = exports.passwordStrengthCheck = void 0;
var _config = _interopRequireDefault(require("./config"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
/* eslint-disable no-plusplus */

var passwordValidationErrors = _config["default"].passwordValidationErrors,
  passwordRegEx = _config["default"].passwordRegEx,
  passwordStrengthRegEx = _config["default"].passwordStrengthRegEx;
var empty = passwordValidationErrors.empty,
  specialCharacters = passwordValidationErrors.specialCharacters,
  minLength = passwordValidationErrors.minLength,
  maxLength = passwordValidationErrors.maxLength,
  lowerCase = passwordValidationErrors.lowerCase,
  upperCase = passwordValidationErrors.upperCase,
  numbers = passwordValidationErrors.numbers;
var validatePassword = exports.validatePassword = function validatePassword(password) {
  var passwordLength = password.length;
  var passwordError = false;
  if (password === '') {
    passwordError = empty;
  } else if (/[^a-zA-Z\d$*%!.,^]/.test(password)) {
    passwordError = specialCharacters;
  } else if (passwordLength < 8) {
    passwordError = minLength;
  } else if (passwordLength > 40) {
    passwordError = maxLength;
  } else if (!/[a-z]/.test(password)) {
    passwordError = lowerCase;
  } else if (!/[A-Z]/.test(password)) {
    passwordError = upperCase;
  } else if (!/[\d]/.test(password)) {
    passwordError = numbers;
  }
  return {
    passwordError: passwordError,
    passwordValidated: passwordRegEx.test(password)
  };
};

// export const passwordStrengthCheck = (password) => { ///Old Password Indicator Functionality for reference
// 	let passwordStrength = 0;

// 	passwordStrengthRegEx.forEach((regex) => {
// 		passwordStrength = regex.validation.test(password) ? (passwordStrength += 1) : passwordStrength;
// 	});
// 	console.log('strength', passwordStrength);
// 	if (passwordStrength === 1) return 'weak';
// 	if (passwordStrength === 2) return 'moderate';
// 	if (passwordStrength === 3) return 'strong';
// 	if (passwordStrength === 4) return 'veryStrong';
// };

var passwordStrengthCheck = exports.passwordStrengthCheck = function passwordStrengthCheck(password) {
  var passwordStrength = 0;
  for (var i = passwordStrengthRegEx.length - 1; i >= 0; i--) {
    if (passwordStrengthRegEx[i].validation.test(password)) {
      passwordStrength = i + 1;
      break;
    }
  }
  switch (passwordStrength) {
    case 1:
      return 'weak';
    case 2:
      return 'moderate';
    case 3:
      return 'strong';
    case 4:
      return 'veryStrong';
    default:
      return 'weak';
  }
};